module.exports = __webpack_public_path__ + "img/2.f6d6d2b4.png";